import styled, { css } from 'styled-components';

import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const SharedAxisStyles = css`
  .tick > line {
    fill: var(--border-soft);
    stroke: var(--border-soft);
    stroke-width: 2;
  }
  .domain {
    fill: var(--border-soft);
    stroke: var(--border-soft);
    stroke-width: 2;
  }

  .tick text {
    font-family: var(--font-nort);
    fill: var(--text-default);
    ${typographyV2.bodyXs};
  }
`;

export const ChartAxisG = styled.g<{ $showLine?: boolean }>`
  ${SharedAxisStyles}
  ${({ $showLine = false }) =>
    $showLine &&
    css`
      .domain {
        display: none;
      }
      .tick > line {
        display: none;
      }
    `}
`;

export const AxisLine = styled.line`
  stroke: var(--border-soft);
`;

export const AxisBorderLine = styled.line`
  stroke: var(--border-soft);
`;
